import contactDetailView from './contactDetailView.json';
import inboxEn from '../en/inbox.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';
import yearInReview from './yearInReview.json';

const messages = {
  ...contactDetailView,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...webhooks,
  ...whatsappTemplates,
  ...yearInReview,
};

// O homolog do Zoraxy usa pt-BR como idioma único. Estes complementos cobrem
// chaves novas que ainda não existem no catálogo pt_BR e evitam fallback para
// inglês enquanto os catálogos upstream são atualizados.
messages.CONTACT_BLOCK_SYNC = {
  LOCAL_BLOCKED: 'Bloqueado no Zoraxy',
  LOCAL_UNBLOCKED: 'Desbloqueado no Zoraxy',
  BLOCK_PENDING: 'Bloqueio no WhatsApp pendente',
  BLOCK_CONFIRMED: 'Bloqueado no WhatsApp',
  BLOCK_FAILED: 'Bloqueio no WhatsApp não confirmado',
  BLOCK_UNAVAILABLE: 'Bloqueio no WhatsApp indisponível',
  BLOCK_UNKNOWN: 'Bloqueio no WhatsApp não confirmado',
  UNBLOCK_PENDING: 'Desbloqueio no WhatsApp pendente',
  UNBLOCK_CONFIRMED: 'Desbloqueado no WhatsApp',
  UNBLOCK_FAILED: 'Desbloqueio no WhatsApp não confirmado',
  UNBLOCK_UNAVAILABLE: 'Desbloqueio no WhatsApp indisponível',
};

messages.AUTOMATION = {
  ...messages.AUTOMATION,
  LAST_RESPONDING_AGENT: 'Último agente a responder',
  ACTIONS: {
    ...messages.AUTOMATION.ACTIONS,
    REMOVE_ASSIGNED_AGENT: 'Remover agente atribuído',
  },
};

messages.INBOX = {
  ...messages.INBOX,
  BADGES: {
    ...messages.INBOX?.BADGES,
    SIDEBAR_TITLE: 'Caixa de Entrada · {count} não lidas',
    SIDEBAR_ARIA_LABEL: 'Caixa de Entrada, {count} não lidas',
    REQUESTS: 'Solicitações: {count}',
    REMINDERS: 'Lembretes: {count}',
    EMAILS: 'E-mails: {count}',
    UNREAD_ITEMS: inboxEn.INBOX.BADGES.UNREAD_ITEMS,
  },
};

messages.SLASH_COMMANDS = {
  ...messages.SLASH_COMMANDS,
  HEADING_1: 'Título 1',
  HEADING_2: 'Título 2',
  HEADING_3: 'Título 3',
  BOLD: 'Negrito',
  ITALIC: 'Itálico',
  STRIKETHROUGH: 'Tachado',
  BULLET_LIST: 'Lista com marcadores',
  ORDERED_LIST: 'Lista numerada',
  TABLE: 'Tabela',
};

messages.EDITOR_TOOLBAR = {
  BOLD: 'Negrito',
  ITALIC: 'Itálico',
  CODE: 'Código',
  LINK: 'Adicionar ou remover link',
  STRIKETHROUGH: 'Tachado',
  BULLET_LIST: 'Lista com marcadores',
  ORDERED_LIST: 'Lista numerada',
  UNDO: 'Desfazer última alteração',
  REDO: 'Refazer última alteração desfeita',
  LINK_PROMPT: {
    TITLE: 'Criar link',
    SUBMIT: 'Criar link',
    CANCEL: 'Cancelar',
  },
};

messages.CONTACT_PANEL = {
  ...messages.CONTACT_PANEL,
  CLICK_TO_EDIT: 'Clique para editar',
};

messages.COMPOSE_NEW_CONVERSATION = {
  ...messages.COMPOSE_NEW_CONVERSATION,
  FORM: {
    ...messages.COMPOSE_NEW_CONVERSATION?.FORM,
    INBOX_SELECTOR: {
      ...messages.COMPOSE_NEW_CONVERSATION?.FORM?.INBOX_SELECTOR,
      LABEL: 'Por:',
    },
  },
};

messages.CONVERSATION = {
  ...messages.CONVERSATION,
  GENERATING_PDF_PREVIEW: 'Gerando a prévia da primeira página…',
  PDF_VIEWER: {
    ...messages.CONVERSATION?.PDF_VIEWER,
    LOADING: 'Carregando documento…',
    LOAD_ERROR: 'Não foi possível exibir este documento.',
    RETRY: 'Tentar novamente',
    NO_PAGE: 'Nenhuma página',
    PAGE_OF: 'Página {current} de {total}',
    PAGE_COUNT: 'Páginas: {count}',
    PREVIOUS_PAGE: 'Página anterior',
    NEXT_PAGE: 'Próxima página',
    GO_TO_MESSAGE: 'Ir para a mensagem',
    STAR: 'Destacar mensagem',
    STARRED: 'Mensagem destacada',
    UNSTARRED: 'Mensagem removida dos destaques',
    PIN: 'Fixar mensagem',
    PINNED: 'Mensagem fixada',
    UNPINNED: 'Mensagem desafixada',
    REACT: 'Reagir',
    REACT_WITH: 'Reagir com {emoji}',
    REACTION_ADDED: 'Reação adicionada',
    MORE_REACTIONS: 'Mais reações',
    FORWARD: 'Encaminhar',
    ZOOM_OUT: 'Reduzir zoom',
    ZOOM_IN: 'Aumentar zoom',
    RESET_ZOOM: 'Redefinir zoom',
  },
  NO_INBOX_1:
    'Olá! Parece que você não adicionou nenhuma caixa de entrada ainda.',
  NO_INBOX_AGENT:
    'Ops! Parece que você não faz parte de nenhuma caixa de entrada. Por favor, contate seu administrador',
};

messages.HELP_CENTER = {
  ...messages.HELP_CENTER,
  EDIT_ARTICLE_PAGE: {
    ...messages.HELP_CENTER?.EDIT_ARTICLE_PAGE,
    EDIT_ARTICLE: {
      ...messages.HELP_CENTER?.EDIT_ARTICLE_PAGE?.EDIT_ARTICLE,
      EDITOR_PLACEHOLDER:
        "Escreva seu conteúdo aqui. Digite '/' para ver as opções de formatação.",
    },
  },
};

messages.INBOX_MGMT = {
  ...messages.INBOX_MGMT,
  ADD: {
    ...messages.INBOX_MGMT?.ADD,
    TELEGRAM_CHANNEL: {
      ...messages.INBOX_MGMT?.ADD?.TELEGRAM_CHANNEL,
      BOT_TOKEN: {
        ...messages.INBOX_MGMT?.ADD?.TELEGRAM_CHANNEL?.BOT_TOKEN,
        LABEL: 'Token do bot',
        PLACEHOLDER: 'Token do bot',
      },
    },
    MICROSOFT: {
      ...messages.INBOX_MGMT?.ADD?.MICROSOFT,
      TITLE: 'E-mail da Microsoft',
    },
  },
};

messages.CAPTAIN = {
  ...messages.CAPTAIN,
  CUSTOM_TOOLS: {
    ...messages.CAPTAIN?.CUSTOM_TOOLS,
    FORM: {
      ...messages.CAPTAIN?.CUSTOM_TOOLS?.FORM,
      RESPONSE_TEMPLATE: {
        ...messages.CAPTAIN?.CUSTOM_TOOLS?.FORM?.RESPONSE_TEMPLATE,
        PLACEHOLDER:
          "Status do pedido {'{{'} order_id {'}}'}: {'{{'} status {'}}'}",
      },
    },
  },
};

messages.LOGIN = {
  ...messages.LOGIN,
  SAML: {
    ...messages.LOGIN?.SAML,
    LABEL: 'Entrar via SSO',
  },
};

messages.MACROS = {
  ...messages.MACROS,
  ACTIONS: {
    ...messages.MACROS?.ACTIONS,
    REMOVE_ASSIGNED_AGENT: 'Remover agente atribuído',
  },
};

export default messages;
